export const InvoiceDic = {
    'walletCredit' : {
        'fa' : 'موجودی کیف پول',
    },
    'creditAuto' : {
        'fa' : 'موجودی شما به طور اتوماتیک از فاکتور شما کسر خواهد شد',
    },
    'coupon' : {
        'fa' : 'کد تخفیف',
    },
    'couponHelp' : {
        'fa' : 'اگر مایل هستید از کد تخفیف استفاده کنید، کافیست کد آن را وارد کرده و با انتخاب دکمه ثبت مبلغ آن از هزینه قابل پرداخت شما کسر می‌شود : '
    },
    'couponSubmit' : {
        'fa' : 'اعمال کد تخفیف'
    },
    'couponIrretrievable' : {
        'fa' : 'بلیت خریداری شده قابل استرداد یا تعویض نمیباشد.'
    },
    'sessionPrice' : {
        'fa' : 'هزینه کلاس'
    },
    'paymentPrice' : {
        'fa' : 'مبلغ قابل پرداخت'
    },
    'agree' : {
        'fa' : 'را قبول دارم'
    },
}